import { storeToRefs } from 'pinia'

import { useRoutingStore } from '~/stores/routing'

export function useNavigateToPreviousPage() {
  const { $pinia } = useNuxtApp()
  const localePath = useLocalePath()
  const { path: routePath } = useRoute()
  const { PREVIOUS: previousStoredRoute } = storeToRefs(useRoutingStore($pinia))

  return {
    /**
     * Navigates to the previous page or sets it back to the supplied fallback url (default's to '/').
     * @param fallbackUrl
     */
    navigateToPreviousPage: function (fallbackUrl: string = '/') {
      if (
        previousStoredRoute.value !== routePath &&
        (previousStoredRoute.value.length ?? 0) > 0
      )
        // TODO: revisit this to see if there's any benefit to go(-1) vs. navigateTo
        return navigateTo(previousStoredRoute.value) // this.$router.go(-1)
      else return navigateTo(localePath(fallbackUrl), { replace: true })
    },
  }
}
